import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import isEqual from 'lodash/isEqual';
import { ACTION_SUBJECT } from '@atlaskit/editor-common/analytics';
import { fg } from '@atlaskit/platform-feature-flags';
import { whichTransitionEvent } from '../../utils/whichTransitionEvent';
import { ErrorBoundary } from '../ErrorBoundary';
import { MountPluginHooks } from './mount-plugin-hooks';
var pluginsComponentsWrapper = css({
  display: 'flex'
});
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
var PluginSlotLegacy = /*#__PURE__*/function (_React$Component) {
  function PluginSlotLegacy() {
    var _this;
    _classCallCheck(this, PluginSlotLegacy);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, PluginSlotLegacy, [].concat(args));
    _defineProperty(_this, "transitionEvent", whichTransitionEvent());
    _defineProperty(_this, "forceComponentUpdate", function (event) {
      // Only trigger an update if the transition is on a property containing `width`
      // This will cater for media and the content area itself currently.
      if (event.propertyName.includes('width')) {
        _this.forceUpdate();
      }
    });
    _defineProperty(_this, "removeModeChangeListener", function (contentArea) {
      if (contentArea && _this.transitionEvent) {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        contentArea.removeEventListener(_this.transitionEvent, _this.forceComponentUpdate);
      }
    });
    _defineProperty(_this, "addModeChangeListener", function (contentArea) {
      if (contentArea && _this.transitionEvent) {
        /**
         * Update the plugin components once the transition
         * to full width / default mode completes
         */
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        contentArea.addEventListener(_this.transitionEvent, _this.forceComponentUpdate);
      }
    });
    return _this;
  }
  _inherits(PluginSlotLegacy, _React$Component);
  return _createClass(PluginSlotLegacy, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var _this$props = this.props,
        editorView = _this$props.editorView,
        editorActions = _this$props.editorActions,
        items = _this$props.items,
        providerFactory = _this$props.providerFactory,
        eventDispatcher = _this$props.eventDispatcher,
        popupsMountPoint = _this$props.popupsMountPoint,
        popupsBoundariesElement = _this$props.popupsBoundariesElement,
        popupsScrollableElement = _this$props.popupsScrollableElement,
        containerElement = _this$props.containerElement,
        disabled = _this$props.disabled,
        wrapperElement = _this$props.wrapperElement;
      return !(nextProps.editorView === editorView && nextProps.editorActions === editorActions && nextProps.items === items && nextProps.providerFactory === providerFactory && nextProps.eventDispatcher === eventDispatcher && nextProps.popupsMountPoint === popupsMountPoint && nextProps.popupsBoundariesElement === popupsBoundariesElement && nextProps.popupsScrollableElement === popupsScrollableElement && nextProps.containerElement === containerElement && nextProps.disabled === disabled && nextProps.wrapperElement === wrapperElement);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.addModeChangeListener(this.props.contentArea);
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.contentArea !== nextProps.contentArea) {
        this.removeModeChangeListener(this.props.contentArea);
        this.addModeChangeListener(nextProps.contentArea);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeModeChangeListener(this.props.contentArea);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        items = _this$props2.items,
        editorView = _this$props2.editorView,
        editorActions = _this$props2.editorActions,
        eventDispatcher = _this$props2.eventDispatcher,
        providerFactory = _this$props2.providerFactory,
        appearance = _this$props2.appearance,
        popupsMountPoint = _this$props2.popupsMountPoint,
        popupsBoundariesElement = _this$props2.popupsBoundariesElement,
        popupsScrollableElement = _this$props2.popupsScrollableElement,
        containerElement = _this$props2.containerElement,
        disabled = _this$props2.disabled,
        dispatchAnalyticsEvent = _this$props2.dispatchAnalyticsEvent,
        wrapperElement = _this$props2.wrapperElement,
        pluginHooks = _this$props2.pluginHooks;
      if (!items && !pluginHooks || !editorView) {
        return null;
      }
      return jsx(ErrorBoundary, {
        component: ACTION_SUBJECT.PLUGIN_SLOT,
        fallbackComponent: null
      }, jsx(MountPluginHooks, {
        editorView: editorView,
        pluginHooks: pluginHooks,
        containerElement: containerElement
      }), jsx("div", {
        css: pluginsComponentsWrapper
      }, items === null || items === void 0 ? void 0 : items.map(function (component, key) {
        var props = {
          key: key
        };
        var element = component({
          editorView: editorView,
          editorActions: editorActions,
          eventDispatcher: eventDispatcher,
          providerFactory: providerFactory,
          dispatchAnalyticsEvent: dispatchAnalyticsEvent,
          // Ignored via go/ees005
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          appearance: appearance,
          popupsMountPoint: popupsMountPoint,
          popupsBoundariesElement: popupsBoundariesElement,
          popupsScrollableElement: popupsScrollableElement,
          containerElement: containerElement,
          disabled: disabled,
          wrapperElement: wrapperElement
        });
        return element && /*#__PURE__*/React.cloneElement(element, props);
      })));
    }
  }]);
}(React.Component);
_defineProperty(PluginSlotLegacy, "displayName", 'PluginSlot');
var PluginSlot = function PluginSlot(_ref) {
  var items = _ref.items,
    editorView = _ref.editorView,
    editorActions = _ref.editorActions,
    eventDispatcher = _ref.eventDispatcher,
    providerFactory = _ref.providerFactory,
    appearance = _ref.appearance,
    popupsMountPoint = _ref.popupsMountPoint,
    popupsBoundariesElement = _ref.popupsBoundariesElement,
    popupsScrollableElement = _ref.popupsScrollableElement,
    containerElement = _ref.containerElement,
    disabled = _ref.disabled,
    dispatchAnalyticsEvent = _ref.dispatchAnalyticsEvent,
    wrapperElement = _ref.wrapperElement,
    pluginHooks = _ref.pluginHooks;
  if (!items && !pluginHooks || !editorView) {
    return null;
  }
  return jsx(ErrorBoundary, {
    component: ACTION_SUBJECT.PLUGIN_SLOT,
    fallbackComponent: null
  }, jsx(MountPluginHooks, {
    editorView: editorView,
    pluginHooks: pluginHooks,
    containerElement: containerElement
  }), jsx("div", {
    css: pluginsComponentsWrapper
  }, items === null || items === void 0 ? void 0 : items.map(function (component, key) {
    var props = {
      key: key
    };
    var element = component({
      editorView: editorView,
      editorActions: editorActions,
      eventDispatcher: eventDispatcher,
      providerFactory: providerFactory,
      dispatchAnalyticsEvent: dispatchAnalyticsEvent,
      // Ignored via go/ees005
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      appearance: appearance,
      popupsMountPoint: popupsMountPoint,
      popupsBoundariesElement: popupsBoundariesElement,
      popupsScrollableElement: popupsScrollableElement,
      containerElement: containerElement,
      disabled: disabled,
      wrapperElement: wrapperElement
    });
    return element && /*#__PURE__*/React.cloneElement(element, props);
  })));
};
var PluginSlotNew = /*#__PURE__*/React.memo(PluginSlot, isEqual);
PluginSlotNew.displayName = 'PluginSlot';
export default function PluginSlotDefault(_ref2) {
  var items = _ref2.items,
    editorView = _ref2.editorView,
    editorActions = _ref2.editorActions,
    eventDispatcher = _ref2.eventDispatcher,
    providerFactory = _ref2.providerFactory,
    appearance = _ref2.appearance,
    popupsMountPoint = _ref2.popupsMountPoint,
    popupsBoundariesElement = _ref2.popupsBoundariesElement,
    popupsScrollableElement = _ref2.popupsScrollableElement,
    containerElement = _ref2.containerElement,
    disabled = _ref2.disabled,
    dispatchAnalyticsEvent = _ref2.dispatchAnalyticsEvent,
    wrapperElement = _ref2.wrapperElement,
    pluginHooks = _ref2.pluginHooks,
    contentArea = _ref2.contentArea;
  if (fg('platform_editor_react_18_plugin_slot')) {
    return jsx(PluginSlotNew, {
      items: items,
      editorView: editorView,
      editorActions: editorActions,
      eventDispatcher: eventDispatcher,
      providerFactory: providerFactory,
      appearance: appearance,
      popupsMountPoint: popupsMountPoint,
      popupsBoundariesElement: popupsBoundariesElement,
      popupsScrollableElement: popupsScrollableElement,
      containerElement: containerElement,
      disabled: disabled,
      dispatchAnalyticsEvent: dispatchAnalyticsEvent,
      wrapperElement: wrapperElement,
      pluginHooks: pluginHooks
    });
  }
  return jsx(PluginSlotLegacy, {
    contentArea: contentArea,
    items: items,
    editorView: editorView,
    editorActions: editorActions,
    eventDispatcher: eventDispatcher,
    providerFactory: providerFactory,
    appearance: appearance,
    popupsMountPoint: popupsMountPoint,
    popupsBoundariesElement: popupsBoundariesElement,
    popupsScrollableElement: popupsScrollableElement,
    containerElement: containerElement,
    disabled: disabled,
    dispatchAnalyticsEvent: dispatchAnalyticsEvent,
    wrapperElement: wrapperElement,
    pluginHooks: pluginHooks
  });
}